import classNames from "classnames";
import React from "react";
import { LazyLoadImage, PriceInCurrency, Link } from "../../../misc";
import { DraggingContext } from "../../../utils";

import "./ItineraryCard.scss";

interface Props {
  content: IContentSampleItinerary;
  className: string;
  heroImageUrl: string;
  heroImageMeta: string;
  renderTags: (content: IContent) => JSX.Element;
  delayClassIndex: number;
  tabIndex?: number;
  onClick?: () => void;
  url: string;
}

/**
 * A card to display an itinerary entry with a link to the entry's page.
 *
 * @status stable
 */
export const ItineraryCard = ({
  content,
  className,
  heroImageUrl,
  heroImageMeta,
  renderTags,
  delayClassIndex,
  onClick,
  tabIndex,
  url
}: Props) => {
  if (!content) {
    return null;
  }

  const itin = content.content;
  return (
    <div className={classNames(className)}>
      <div className="card-header-wrapper">
        <div className="image-container">
          <div className="card-darkener"></div>
          <LazyLoadImage src={heroImageUrl} alt={heroImageMeta} />
        </div>
        <div className="card-info-wrapper">
          <div className="card-days text--label">
            {itin.numberOfDays} day{itin.numberOfDays > 1 && "s"}
          </div>
          {itin.pricePerPerson &&
            <div className="card-price text--label">
              from{" "}
              <PriceInCurrency
                priceInCurrency={itin.pricePerPerson}
                roundUpToNearest={10}
              />
              {" "} pp
            </div>
          }
        </div>
      </div>
      <div className="card-body">
        <h3 className="card-title text--dark">{content.title}</h3>
        <div className="card-tags">{renderTags(content)}</div>
      </div>

      <DraggingContext.Consumer>
        {props => <Link
          {...props}
          className="card-link"
          to={url}
          tabIndex={tabIndex || 0}
          onClick={onClick}
        />}
      </DraggingContext.Consumer>
    </div>
  );
};
